import { Component, OnInit, DestroyRef, inject } from '@angular/core';
import { SearchService } from '../../common/services/search.service';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthService } from '../../common/services/auth.service';
import { SiteService } from '../../common/services/site.service';
import { PreviewService } from '../../common/services/preview.service';

@Component({
    selector: 'app-root',
    templateUrl: './layout.component.html',
    styleUrl: './layout.component.scss',
    standalone: false
})
export class LayoutComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  
  title = 'api-explorer-frontend-app';
  theme: string = 'dark-mode';

  showSideNav: boolean = true;
  mainContentWidth = 420;
  isSearching: boolean = false;
  searchQuery: string = '';
  searchFilter: Array<any> = [];
  typeFilter: Array<any> = [];
  loggedIn = false;
  isPreview = false;
  
  constructor(  private searchService: SearchService, 
                private authService: AuthService,
                private router: Router,
                private siteService: SiteService,
                private previewService: PreviewService,
  ) {
    this.router.events.subscribe(() => {
      this.checkRoute();
    });
    
  }
 
  checkRoute() {
    const hideOnRoutes = ['/login', '/request', '/password'];
    const currentRoute = this.router.url;

    this.showSideNav = !hideOnRoutes.includes(currentRoute);
  }

  ngOnInit() {

    this.searchService.isSearching$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((isSearching) => {
      this.isSearching = isSearching;
    });

    this.searchService.searchQuery$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((searchQuery) => {
      this.searchQuery = searchQuery;
    });

    this.searchService.typeFilter$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((typeFilter) => {
      this.typeFilter = typeFilter;
    });

    this.authService.loggedIn$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(loggedIn => {
      this.loggedIn = loggedIn; 
    });

    this.siteService.theme$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe(theme => {
      this.theme = theme; 
      this.siteService.updateTheme( this.theme );
    });

    this.previewService.previewMode$.pipe(
        takeUntilDestroyed(this.destroyRef)
      ).subscribe((previewMode) => {
      this.isPreview = previewMode;
    });

    document.addEventListener('keydown', this.onKeydown.bind(this));
  }

  // Setting key listeners
  onKeydown(event: KeyboardEvent) {
    let searchInput = document.querySelector(
      '#searchInput'
    ) as HTMLInputElement;
    // If key pressed is escape, hide search component
    if (event.key === 'Escape') {
      this.searchService.resetSearch();
      searchInput.value = '';
    }
    // If key pressed is ctrl,command + K, focus the search bar
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k') {
      event.preventDefault();
      this.focusInput();
    }
  }

  private focusInput() {
    let searchInput = document.querySelector(
      '#searchInput'
    ) as HTMLInputElement;
    if (searchInput) {
      searchInput.focus();
    }
  }
}
